import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'

import { Tabbar, TabbarItem, Swipe, SwipeItem, NavBar, Checkbox, CheckboxGroup, Stepper, SubmitBar, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton, Popup, Card, RadioGroup, Radio, AddressEdit, Field, Cell, CellGroup, Area, Tab, Tabs, CountDown, Step, Steps, Dialog, Toast, Loading, Picker, List, PullRefresh ,Uploader } from "vant";

Vue.use(Tabbar).use(TabbarItem).use(Swipe).use(SwipeItem).use(NavBar).use(Checkbox).use(CheckboxGroup).use(Stepper).use(SubmitBar).use(Icon).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton).use(Popup).use(Card).use(RadioGroup).use(Radio).use(AddressEdit).use(Field).use(Cell).use(CellGroup).use(Area).use(Tab).use(Tabs).use(CountDown).use(Step).use(Steps).use(Dialog).use(Toast).use(Loading).use(Picker).use(List).use(PullRefresh).use(Uploader);

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
